import React from 'react';
import {
  Container,
  Header,
  Grid,
  List,
  Segment,
  Image
} from 'semantic-ui-react';

import './TopMenu.css';

class Footer extends React.Component {
  render() {
    return (
      <Segment inverted vertical style={{ padding: '3em 0em' }}>
        <Container>
          <Grid divided inverted stackable>
            <Grid.Row>
              <Grid.Column width={4}>
                <Image
                  src="/images/TEL_logo_land_neg_outline_teal.png"
                  style={{ marginRight: '1.5em' }}
                />
                <p />
                <p></p>
              </Grid.Column>
              <Grid.Column width={4}>
                <Header inverted as="h4" content="About" />
                <List inverted>
                  <List.Item>
                    <a href="https://trojan.energy" target="_parent">
                      How it Works
                    </a>
                  </List.Item>
                  <List.Item>
                    <a href="https://trojan.energy/about-us" target="_parent">
                      About Us
                    </a>
                  </List.Item>
                  <List.Item>
                    <a href="https://trojan.energy/contact-us" target="_parent">
                      Contact Us
                    </a>
                  </List.Item>
                </List>
              </Grid.Column>
              <Grid.Column width={4}></Grid.Column>
              {/* <Grid.Column width={4}>
                <Header inverted as="h4" content="Contact" />
                <List link inverted>
                  <List.Item>
                    <a

                    >
                      Support
                    </a>
                  </List.Item>
                  <List.Item>
                    <a
                      href="https://trojan.energy/#customers"
                      target="_parent"
                    >
                      Invites
                    </a>
                  </List.Item>
                  <List.Item>
                    <a
                      href="https://trojan.energy/#councils"
                      target="_parent"
                    >
                      PR
                    </a>
                  </List.Item>
                </List>
              </Grid.Column> */}
            </Grid.Row>
          </Grid>
        </Container>
      </Segment>
    );
  }
}

export { Footer };
